import React, { Fragment } from "react";
import {
  FormBlock,
  FormTitle,
  BlockFormMain,
  FormRow,
  HalfBlock,
  FormName,
  ActionForm,
} from "../../../generalStyles/mixin";
import InputComponent from "../../inputText";
import SelectComponent from "../../selectInput";
import Buttons, { BtnAction } from "../../button";
import {
  getTaskOptions,
  getEngineOptions,
  getFinishMaxDate,
} from "./../../utils/utils";
import getColumsInstance from "./header-table"
import * as env from "../../../environment";
import InputDateComponent from "../../inputDate";
import InputError from "../../inputError";
import ReactTable from "react-table";
import Pagination from "../../pagination/pagination";
import { TableTitle } from "../../pagination/styles";
import "react-table/react-table.css";
import "../../pagination/styles.css";
import { format } from "date-fns";
import Modal from "../../modal";
import Template from "../../modal/tempalte";
//import DownloadData from "../../button/download-data";
import ExcelExport from "../../button/ExcelExport";
import DetailComponent from '../../detail';
const { API_URL_MOTOR } = env[process.env.NODE_ENV];

class InstancesComponent extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      token: localStorage.getItem("token"),
      data: [],
      operationNumber: "",
      startDate: "",
      endDate: "",
      flowsSelected: "",
      taskSelected: "",
      processId: "",
      contextBoxes: [],
      taskBoxes: [],
      paginator: "",

      pageSize: 10,
      paginatorDownload: 0,
      dataDownload: [],
      showPrepare: false,

      //manejo de errores
      //status
      sOperationNumber: false,
      sStartDate: false,
      sEndDate: false,
      sProcessId: false,

      //msj
      mOperationNumber: "",
      mStartDate: "",
      mEndDate: "",
      mProcessId: "",

      idOrder: "",
      engineId: "",
      visible: true,
    };

  }

  getContextArray() {
    let apiUrlEngineContext = `${API_URL_MOTOR}/api/engine/context/all`;
    let endpoint = apiUrlEngineContext;
    let optionsResponse = getEngineOptions(endpoint, "name", "idContext");
    this.setState({ contextBoxes: optionsResponse });
  }

  getTaskOptions(idContext) {
    let apiUrlEngineTask = `${API_URL_MOTOR}/api/engine/task/`;
    let endpoint = apiUrlEngineTask + idContext;
    let optionsResponse = getTaskOptions(endpoint, "name", "idContext");
    this.setState({ taskBoxes: optionsResponse, taskSelected: "" });
  }

  componentDidMount() {
    this.getContextArray();
  }

  handlerVisible = (visible) => {
    this.setState({
      visible: visible
    });
  }
  render() {
    if (localStorage.getItem('perfiles').includes('Admin')) {
      return (
        <Fragment>
          {this.state.visible ? (
            <form onSubmit={this.handleSubmit}>
              <FormBlock>
                <FormTitle>Consulta Instancias</FormTitle>
                <BlockFormMain>
                  <HalfBlock>
                    <FormRow>
                      <FormName>Número operación</FormName>
                      <InputComponent
                        onChange={this.onChange}
                        value={this.state.operationNumber}
                        name="operationNumber"
                      />
                    </FormRow>
                    <InputError
                      isShow={this.state.sOperationNumber}
                      value={this.state.mOperationNumber}
                    ></InputError>
                    <FormRow>
                      <FormName>Fecha de Inicio</FormName>
                      <InputDateComponent
                        onChange={this.onChangeStartDate}
                        ref="startDate"
                      />
                    </FormRow>
                    <InputError
                      isShow={this.state.sStartDate}
                      value={this.state.mStartDate}
                    ></InputError>
                    <FormRow>
                      <FormName>Fecha de Termino</FormName>
                      <InputDateComponent
                        onChange={this.onChangeEndDate}
                        ref="finishDate"
                      />
                    </FormRow>
                    <InputError
                      isShow={this.state.sEndDate}
                      value={this.state.mEndDate}
                    ></InputError>
                  </HalfBlock>
                  <HalfBlock>
                    <FormRow>
                      <FormName>Flujos</FormName>
                      <SelectComponent
                        options={this.state.contextBoxes}
                        onChange={this.onChangeBoxesFlows}
                        ref="selectFlow"
                      />
                    </FormRow>
                    <InputError
                      isShow={this.state.sFlowsSelected}
                      value={this.state.mFlowsSelected}
                    ></InputError>
                    <FormRow>
                      <FormName>Tarea</FormName>
                      <SelectComponent
                        options={this.state.taskBoxes}
                        onChange={this.onChangeBoxesTask}
                        ref="selectTask"
                      />
                    </FormRow>
                    <InputError
                      isShow={this.state.sTaskSelected}
                      value={this.state.mTaskSelected}
                    ></InputError>
                    <FormRow>
                      <FormName>Nombre de Archivo</FormName>
                      <InputComponent
                        onChange={this.onChange}
                        value={this.state.processId}
                        name="processId"
                      />
                    </FormRow>
                    <InputError
                      isShow={this.state.sProcessId}
                      value={this.state.mProcessId}
                    ></InputError>
                  </HalfBlock>
                </BlockFormMain>
                <ActionForm>
                  <Buttons.Primary>Buscar</Buttons.Primary>
                  <Buttons.Clear
                    type="none"
                    onClick={(e) => {
                      e.preventDefault();
                      this.setState({
                        operationNumber: "",
                        startDate: "",
                        endDate: "",
                        flowsSelected: "",
                        taskSelected: "",
                        processId: "",
                        sOperationNumber: false,
                        sStartDate: false,
                        sEndDate: false,
                        sProcessId: false,
                      });
                      this.refs.startDate.setState({ startDate: "" });
                      this.refs.finishDate.setState({ startDate: "" });
                      this.refs.selectTask.setState({ selectedOption: null });
                      this.refs.selectFlow.setState({ selectedOption: null });
                    }}
                  >
                    Limpiar
                </Buttons.Clear>
                </ActionForm>
              </FormBlock>
            </form>
          ) : (
            <Fragment>
              <TableTitle>SECCION DE DETALLES</TableTitle>
              <DetailComponent action={this.handlerVisible}
                otroDato={{ idOrder: this.state.idOrder, engineId: this.state.engineId }}></DetailComponent>
            </Fragment>
          )}

          {this.state.data.length > 0 ? (
            <Fragment>
              <TableTitle>Resultado de Búsqueda</TableTitle>
            </Fragment>
          ) : (
            ""
          )}
          {this.state.data.length > 0 ?
            (
              <Fragment>
                {(this.state.showPrepare) ?
                  
                  <ExcelExport data={this.state.dataDownload} fileName="datos" />
                  : <Buttons.Primary style={{ height: "32px", margin: "20px", marginTop: "-8px" }} onClick={this.dataExcel}>Preparar reporte</Buttons.Primary>
                }

                <select
                  style={{ border: "1px solid #CCC", cursor: "pointer", width: "200px", padding: "5px", marginBottom: "10px", fontSize: "14px" }}
                  value={this.state.pageSize}
                  onChange={e => {
                    this.setState({ data: [] })
                    this.setPageSize(Number(e.target.value));
                  }}>
                  {
                    [10, 25, 50, 100].map(pageSize => (
                      <option key={pageSize} value={pageSize}>
                        Mostrando: {pageSize}
                      </option>
                    ))
                  }
                </select>

                <ReactTable
                  PaginationComponent={Pagination}
                  getTdProps={this.onRowClicks}
                  data={this.state.data}
                  columns={getColumsInstance()}
                  previousText={"Anterior"}
                  nextText={"Siguiente"}
                  resizable={false}
                  pages={this.state.paginator.totalPageNumber}
                  canNext={(this.state.paginator.totalPageNumber > 1) ? true : false}
                  manual
                  onFetchData={this.handlePageChange}
                  defaultPageSize={
                    this.state.data.length >= 10 ? 10 : this.state.data.length
                  }
                  noDataText={"No hay registros"}
                  style={{ textAlign: "center" }}
                  className="-striped -highlight"
                />
              </Fragment>
            ) : null}
          <Modal
            show={this.state.isOpen}
            onClose={() => {
              this.state.isClosable
                ? this.setState({
                  isOpen: !this.state.isOpen,
                })
                : console.warn("worker on something...");
            }}
          >
            <Template name={this.state.modalChildren} />
          </Modal>
        </Fragment>
      );
    } else {
      this.props.history.push('/home/consult/estadoPago');
      return "";
    }
  }

  setPageSize = (e) => {
    console.clear()
    console.log('eeeeeeeee', e)
    this.setState({ pageSize: e });

    let endpoint = `${API_URL_MOTOR}/api/instance/find`;
    this.searchInstances(endpoint, e);
  }

  handleSubmit = (e) => {
    e.preventDefault();
    this.state.pageSize = 10;
    this.setState({ data: [], dataDownload: [], showPrepare: false });
    // console.log(this.state.data);
    if (!this.validation(this.state)) {
      console.warn("invalid data");
      return;
    }

    let endpoint = `${API_URL_MOTOR}/api/instance/find`;
    this.searchInstances(endpoint, this.state.pageSize);
  };

  handlePageChange = async (tableState, _instance) => {
    console.log('tableState.page: ' + tableState.page);
    const pageNum = tableState.page + 1;
    await this.toPage(pageNum, this.state.pageSize);
  }

  toPage(page, pageSize) {
    if (this.state.paginator != "") {
      this.state.paginator.currentPageNumber = page;
    }
    let endpoint = `${API_URL_MOTOR}/api/instance/find`;
    this.searchInstances(endpoint, pageSize);
  }


  dataExcel = async () => {
    console.clear();
    let endpoint = `${API_URL_MOTOR}/api/instance/find`;
    let datos = await this.dataMatch(endpoint)

    if (!datos) {
      console.log('LISTO PARA EXPORTAR!')
      this.setState({ showPrepare: true, paginatorDownload: 0 });
    }
  }


  dataMatch = async (endpoint) => {
    let request = this.generateRequestDownload(true);
    console.log('request', request)
    var json = JSON.stringify(request);
    const requestOptions = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        //Authorization: this.state.token,
      },
      body: JSON.parse(json),
    };

    this.setState({
      isOpen: true,
      modalChildren: "loader",
      isClosable: false,
    });


    let result = await fetch(endpoint, requestOptions);
    let data = await result.json();
    let searchResult = this.generateData(data);

    if (searchResult.length > 0) {
      console.log('Hay Datos! Nro de pagina: ', this.state.paginatorDownload)
      searchResult.map(res => {
        this.state.dataDownload.push(res);
      });

      this.setState({
        isOpen: false,
        modalChildren: "",
        isClosable: false,
      });

      return await this.dataMatch(endpoint);
    } else {
      this.setState({
        isOpen: false,
        modalChildren: "",
        isClosable: false,
      });
      return false;
    }
  }


  generateRequestDownload(withPaginator) {
    let request = "{";

    if (withPaginator == true) {
      let currentPage = this.state.paginatorDownload + 1;
      this.setState({ paginatorDownload: currentPage });
      // agregar paginador
      request = request + '"paginator": {"currentPageNumber": ' + currentPage + ', "pageSize": 1000},';
    }

    if (
      this.state.operationNumber !== undefined &&
      this.state.operationNumber !== "" &&
      this.state.operationNumber !== "-1"
    ) {
      request = request + '"businessId": "' + this.state.operationNumber + '",';
    } else {
      request = request + '"businessId": null,';
    }
    if (
      this.state.endDate !== undefined &&
      this.state.endDate !== "" &&
      this.state.endDate !== null
    ) {
      request =
        request +
        '"operationDateEnd": "' +
        format(new Date(this.state.endDate), "yyyy-MM-dd") +
        '",';
    } else {
      request = request + '"operationDateEnd": null,';
    }
    if (
      this.state.startDate !== undefined &&
      this.state.startDate !== "" &&
      this.state.startDate !== null
    ) {
      request =
        request +
        '"operationDateStart": "' +
        format(new Date(this.state.startDate), "yyyy-MM-dd") +
        '",';
    } else {
      request = request + '"operationDateStart": null,';
    }
    if (
      this.state.flowsSelected !== undefined &&
      this.state.flowsSelected !== "" &&
      this.state.flowsSelected !== "-1"
    ) {
      request = request + '"idContext": ' + this.state.flowsSelected + ",";
    } else {
      request = request + '"idContext": 0,';
    }
    if (
      this.state.taskSelected !== undefined &&
      this.state.taskSelected !== "" &&
      this.state.taskSelected !== "-1"
    ) {
      request = request + '"taskName": "' + this.state.taskSelected + '",';
    } else {
      request = request + '"taskName": null,';
    }

    if (
      this.state.processId !== undefined &&
      this.state.processId !== "" &&
      this.state.processId !== "-1"
    ) {
      request = request + '"processId": "' + this.state.processId + '",';
    } else {
      request = request + '"processId": null,';
    }

    request = request.substring(0, request.length - 1);
    request = request + "}";

    return request;
  }


  generateRequest(withPaginator, pageSize) {
    let request = "{";

    if (withPaginator == true) {
      let currentPage = 1;
      if (this.state.paginator != null && this.state.paginator != "" && pageSize === this.state.pageSize) {
        currentPage = this.state.paginator.currentPageNumber;
      }
      // agregar paginador
      request = request + '"paginator": {"currentPageNumber": ' + currentPage + ', "pageSize": ' + pageSize + '},';
    }

    if (
      this.state.operationNumber !== undefined &&
      this.state.operationNumber !== "" &&
      this.state.operationNumber !== "-1"
    ) {
      request = request + '"businessId": "' + this.state.operationNumber + '",';
    } else {
      request = request + '"businessId": null,';
    }
    if (
      this.state.endDate !== undefined &&
      this.state.endDate !== "" &&
      this.state.endDate !== null
    ) {
      request =
        request +
        '"operationDateEnd": "' +
        format(new Date(this.state.endDate), "yyyy-MM-dd") +
        '",';
    } else {
      request = request + '"operationDateEnd": null,';
    }
    if (
      this.state.startDate !== undefined &&
      this.state.startDate !== "" &&
      this.state.startDate !== null
    ) {
      request =
        request +
        '"operationDateStart": "' +
        format(new Date(this.state.startDate), "yyyy-MM-dd") +
        '",';
    } else {
      request = request + '"operationDateStart": null,';
    }
    if (
      this.state.flowsSelected !== undefined &&
      this.state.flowsSelected !== "" &&
      this.state.flowsSelected !== "-1"
    ) {
      request = request + '"idContext": ' + this.state.flowsSelected + ",";
    } else {
      request = request + '"idContext": 0,';
    }
    if (
      this.state.taskSelected !== undefined &&
      this.state.taskSelected !== "" &&
      this.state.taskSelected !== "-1"
    ) {
      request = request + '"taskName": "' + this.state.taskSelected + '",';
    } else {
      request = request + '"taskName": null,';
    }

    if (
      this.state.processId !== undefined &&
      this.state.processId !== "" &&
      this.state.processId !== "-1"
    ) {
      request = request + '"processId": "' + this.state.processId + '",';
    } else {
      request = request + '"processId": null,';
    }

    request = request.substring(0, request.length - 1);
    request = request + "}";

    return request;
  }

  generateData(response) {
    let searchResponse = [];
    let i = 0;
    if (response.instances !== null) {
      for (i = 0; i < response.instances.length; i++) {
        var fDate = "";
        if (response.instances[i]["finishDate"] != null && response.instances[i]["finishDate"] != "") {
          fDate = format(new Date(response.instances[i]["finishDate"]), "dd/MM/yyyy HH:mm:ss");
        }
        searchResponse.push({
          "businessId": response.instances[i]["businessId"],
          "creatDate": format(new Date(response.instances[i]["creatDate"]), "dd/MM/yyyy HH:mm:ss"),
          "statusName": response.instances[i].status["name"],
          "finishDate": fDate,
          "leadtime": response.instances[i]["leadtime"],
          "contextName": response.instances[i].context["name"],
          "idInstance": response.instances[i]["idInstance"]
        });
      }
    }
    return searchResponse;
  }

  /**
   * Busqueda de instancias
   */
  searchInstances = (endpoint, pageSize) => {
    let searchResponse = [];
    let request = this.generateRequest(true, pageSize);

    // quitar caracteres de escape
    var json = JSON.stringify(request);
    console.log("request : " + JSON.parse(json));
    const requestOptions = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        //Authorization: this.state.token,
      },
      body: JSON.parse(json),
    };
    this.setState({
      isOpen: true,
      modalChildren: "loader",
      isClosable: false,
    });

    setTimeout(() => {
      this.setState({
        isClosable: true,
      });
    }, 2000);


    fetch(endpoint, requestOptions).then((result) => {
      if (result.ok) {
        result
          .json()
          .then((response) => {
            searchResponse = this.generateData(response);
            this.setState({ data: searchResponse, paginator: response.paginator });
            if (this.state.data === null || this.state.data.length === 0) {
              this.setState({
                modalChildren: "notFound",
                isClosable: true,
              });
            } else {
              this.setState({
                isOpen: false,
                modalChildren: "",
                isClosable: false,
              });
            }
          })
          .catch((error) => {
            console.log(
              "Hubo un problema con la petición Fetch:" + error.message
            );
            this.setState({
              isOpen: true,
              modalChildren: "error",
              isClosable: true,
            });
          });
      }
    });
  };

  onChange = (e) => {
    this.setState({
      [e.name]: e.value,
    });
  };
  onChangeBoxesFlows = (e) => {
    this.setState({
      flowsSelected: e.value,
    });
    // Cargamos tareas segun contexto seleccionado
    this.refs.selectTask.setState({ selectedOption: null });
    this.getTaskOptions(e.value);
  };
  onChangeBoxesTask = (e) => {
    this.setState({
      taskSelected: e.label,
    });
  };
  onChangeStartDate = (e) => {
    this.setState({
      startDate: e,
    });

    this.refs.finishDate.setState({
      maxDate: new Date(getFinishMaxDate(e)),
      minDate: e,
      startDate: "",
    });
  };
  onChangeEndDate = (e) => {
    this.setState({
      endDate: e,
    });
  };

  onRowClicks = (state, rowInfo, instance) => {
    return {
      onClick: () => {
        this.setState({
          visible: false,
          idOrder: rowInfo.row._original.businessId,
          engineId: rowInfo.row._original.idInstance
        });
      }
    }
  }
  validation = (state) => {
    const { operationNumber, startDate, endDate, processId } = state;
    if (startDate === null || endDate === null) {
      this.setState({
        sOperationNumber: true,
        mOperationNumber: "Campo Obligatorio",
        sStartDate: true,
        mStartDate: "Campo Obligatorio",
        sEndDate: true,
        mEndDate: "Campo Obligatorio",
        sProcessId: true,
        mProcessId: "Campo Obligatorio",
      });
      return false;
    }
    if (operationNumber !== "" || startDate !== "" || endDate !== "" || processId !== "") {
      this.setState({
        sOperationNumber: false,
        mOperationNumber: "",
        sStartDate: false,
        mStartDate: "",
        sEndDate: false,
        mEndDate: "",
        isOpen: false,
        modalChildren: "",
        isClosable: false,
        sProcessId: false,
        mProcessId: "",
      });
      return true;
    } else {
      this.setState({
        sOperationNumber: true,
        mOperationNumber: "Campo Obligatorio",
        sStartDate: true,
        mStartDate: "Campo Obligatorio",
        sEndDate: true,
        mEndDate: "Campo Obligatorio",
        sProcessId: true,
        mProcessId: "Campo Obligatorio",
      });
      return false;
    }
  };
}

export default InstancesComponent;
